import {ModelEntity} from '../../entity/model.entity';
import {FieldRelationKind} from '../../enum/field.relation.kind';
import {FieldTypeKind} from '../../enum/field.type.kind';
import {INickOptionsField} from '../../interface/nick.i.options.field';
import {INickPrefixField} from '../../interface/nick.i.prefix.field';
import {INickSearchField} from '../../interface/nick.i.search.field';

export class Metadata {

    public name: string;
    public id: string;
    public aliasId: string;

    [key: string]: any;

    public fieldId: string;
    public columnName: string;
    public oldColumnName: string;
    public columnType: FieldTypeKind;
    public isPrimaryKey: boolean = false;
    public allowNull: boolean = true;
    public unique: boolean = false;
    public constraint: boolean;
    public isForeignKey: boolean = false;
    public foreignKey: string = '';
    public targetKey: string;
    public sourceKey: string;
    public joinEntity: { new(...args: any[]): any };
    public hasOne: boolean;
    public autoIncrement: boolean;
    public required: boolean;
    public hidden: boolean;
    public readOnly: boolean;
    public defaultValue: any;
    public relation: FieldRelationKind;
    public relationName: string;
    public enumType: string;
    public modelType: string;
    public modelForeignKey: string;
    public modelTableName: string;
    public modelTypeMetadata: Metadata[];
    public modelTypeEntity: ModelEntity;
    public search: INickSearchField;
    public filter: any;
    public prefix: INickPrefixField;
    public text: string;
    public options: INickOptionsField;
    public calculateField: any[];
    public kind: number;
}
